import {
  Clock, Smile, Award, Search, SprayCan, Droplets, CalendarRange, FileText, Gift, BadgeCheck, ShieldCheck,
} from "lucide-react";
import { container, sectionPad, label, cardShadow } from "@/lib/ui";

const REASONS = [
  { icon: Clock, title: "Reliable", desc: "We turn up on time and do what we say — dependability you can plan your week around." },
  { icon: Smile, title: "Friendly", desc: "A warm, approachable team you'll feel comfortable welcoming into your home." },
  { icon: Award, title: "Professional", desc: "Careful, consistent cleaning delivered to a high standard every visit." },
  { icon: Search, title: "Attention to Detail", desc: "We focus on the little things most cleaners miss." },
  { icon: SprayCan, title: "Equipment Supplied", desc: "We bring our own professional cleaning equipment." },
  { icon: Droplets, title: "Products Supplied", desc: "Quality cleaning products are included — nothing for you to buy." },
  { icon: CalendarRange, title: "Flexible Scheduling", desc: "Weekly, fortnightly, monthly or one-off — on a schedule that suits you." },
  { icon: FileText, title: "Personalised Quotes", desc: "Every quote is tailored to your home and the service you need." },
  { icon: Gift, title: "Free Quotes", desc: "No-obligation quotes, always free." },
  { icon: BadgeCheck, title: "ABN Registered", desc: "A registered Australian business you can trust." },
  { icon: ShieldCheck, title: "Public Liability Insurance", desc: "Fully insured for your complete peace of mind." },
];

export function WhyChooseUs() {
  return (
    <section className={`${sectionPad} bg-white`} data-testid="why-choose-us">
      <div className={container}>
        <div className="max-w-2xl">
          <span className={label}>Why Choose Us</span>
          <h2 className="mt-3 font-heading text-3xl lg:text-4xl font-bold tracking-tight text-navy">
            Genuine reasons Melbourne homes choose us
          </h2>
          <p className="mt-4 text-gray-600 leading-relaxed">
            No inflated claims — just the real advantages that make our residential cleaning dependable,
            thorough and stress-free.
          </p>
        </div>

        <div className="mt-12 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {REASONS.map((r, i) => {
            const Icon = r.icon;
            return (
              <div
                key={r.title}
                className={`rounded-2xl bg-neutralbg/70 border border-gray-100 p-6 transition-transform duration-300 hover:-translate-y-1 hover:bg-white ${cardShadow}`}
                data-testid={`reason-${i}`}
              >
                <span className="grid place-items-center w-12 h-12 rounded-xl bg-navy">
                  <Icon className="w-6 h-6 text-brandgreen-light" strokeWidth={2} />
                </span>
                <h3 className="mt-4 font-heading text-lg font-semibold text-navy">{r.title}</h3>
                <p className="mt-1.5 text-sm text-gray-600 leading-relaxed">{r.desc}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
